import React from "react";
import EdButton from "../../generic/edButton";
import "../../../assets/scss/components/toc/fundTransfer/generic/ftConfirmBtn.scss";
export interface IFtConfirmBtnProps {
	errTxt?: string; // Error text if passed then button is in disabled state
	onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
	disbaled: boolean;
}

const FtConfirmBtn: React.FC<IFtConfirmBtnProps> = (props: IFtConfirmBtnProps) => {
	return (
		<div className="fTConfirmBtns">
			{props.errTxt ? (
				<div className="error_state btn_container">
					<p className="err-txt">{props.errTxt}</p>
					<EdButton value="Confirm" btnTyp="primary" disabled={props.disbaled} onClick={props.onClick} className="confirm_btn" />
				</div>
			) : (
				<div className="btn_container">
					<EdButton value="Confirm" btnTyp="primary" disabled={props.disbaled} onClick={props.onClick} className="confirm_btn" />
				</div>
			)}
		</div>
	);
};

export default FtConfirmBtn;
